import { render, staticRenderFns } from "./CustomerFoodSelection.vue?vue&type=template&id=38618698&scoped=true"
import script from "./CustomerFoodSelection.vue?vue&type=script&lang=js"
export * from "./CustomerFoodSelection.vue?vue&type=script&lang=js"
import style0 from "./CustomerFoodSelection.vue?vue&type=style&index=0&id=38618698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38618698",
  null
  
)

export default component.exports